import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,zeroFill } from "common/SharedFn";
import { getAllDrivers,addDriver,updateDriver, getAllVechicles, getAllShifts, assignVehicle, assignShift, getAllOrdersByDriverId } from "../../network/ApiAxios";
import {  Check,Block, Edit, DirectionsCar, TimerRounded, Assessment } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DriversTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [driversList, setDriversList] = useState([]);
  // const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [addVehicleModal, setAddVehicleModal] = useState(false);
  const [addShiftModal, setAddShiftModal] = useState(false);
  const [orderDelayReportModal, setOrderDelayReportModal] = useState(false);

  const [vehicles, setVehicles] = useState([]);
  const [shifts, setShifts] = useState([]);

  const [selectedDriverVehicle, setSelectedDriverVehicle] = useState("");
  const [selectedDriverShift, setSelectedDriverShift] = useState("");
  const [selectedDriverForReport, setSelectedDriverForReport] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterType, setFilterType] = useState("pickup");
  const [isDownloading, setIsDownloading] = useState(false);


  const [fullNameEn, setFullNameEn] = useState("");
  const [fullNameAr, setFullNameAr] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");

  const [isActive, setIsActive] = useState(1);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  let history = useHistory();
  
  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id,fullNameEn,fullNameAr,mobileNumber,isActive} = info;
    setFullNameEn(fullNameEn);
    setFullNameAr(fullNameAr);
    setMobileNumber(mobileNumber);
    setIsActive(isActive);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setFullNameEn("");
    setFullNameAr("");
    setMobileNumber("");
    setIsActive(1);
    setId();
  };
  

  const fetchDrivers = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllDrivers();
    const { data } = response;
    // const responseCountries = await getAllCountries();
    if (data.result.isSuccess) {
      console.log(data.data);
      // setCountries(responseCountries.data.data);
      setData(data.data.map((prop) => makeTableRow(prop)));
      setDriversList(data.data); // Store the original drivers data
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch drivers");
    }
    setIsLoading(false);
  };

  const fetchVehicles = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllVechicles();
    const { data } = response;
    // const responseCountries = await getAllCountries();
    if (data.result.isSuccess) {
      // setCountries(responseCountries.data.data);
      setVehicles(data.data.filter(function(vehicle) {
        return vehicle.enabled == 1;
      }));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch vehicles");
    }
    setIsLoading(false);
  };

  const fetchShifts = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllShifts();
    const { data } = response;
    // const responseCountries = await getAllCountries();
    if (data.result.isSuccess) {
      // setCountries(responseCountries.data.data);
      // filter shifts that are not enabled
      setShifts(data.data.filter(function(shift) {
        return shift.isEnabled == 1;
      }));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch vehicles");
    }
    setIsLoading(false);
  };



  const addDriverAction = async () => {
    setIsLoading(true);
    try{
    const response = await addDriver(fullNameEn,fullNameAr,mobileNumber,isActive);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Driver Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add driver");
      setIsLoading(false);
    }
  };


  const assignVehicleAction = async () => {
    setIsLoading(true);
    try{
      const response = await assignVehicle(id,selectedDriverVehicle);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Vehicle " + selectedDriverVehicle  + " Assigned Successfully to Driver " + fullNameEn);
        setAddVehicleModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch(ex){
      showErrorNotification("Failed to assign vehicle");
      setIsLoading(false);
    }
  };

  const assignShiftAction = async () => {
    setIsLoading(true);
    try{
      const response = await assignShift(id, selectedDriverShift);
      const { data } = response;
      if (data.result.isSuccess) {
        showSuccessNotification("Shift " + selectedDriverShift  + " Assigned Successfully to Driver " + fullNameEn);
        setAddShiftModal(false);
        setForceRefresh(true);
      } else {
        showErrorNotification(data.result.description);
        setIsLoading(false);
      }
    }
    catch(ex){
      showErrorNotification("Failed to assign vehicle");
      setIsLoading(false);
    }
  };

  const downloadOrderDelayReport = async () => {
    if (!selectedDriverForReport || !startDate || !endDate) {
      showErrorNotification("Please select a driver and both start and end dates.");
      return;
    }

    setIsDownloading(true);
    try {
      // Format dates for API request
      const startDateTime = new Date(startDate + "T00:00:00.000Z");
      const endDateTime = new Date(endDate + "T23:59:59.999Z");

      const response = await getAllOrdersByDriverId(
        startDateTime.toISOString(),
        endDateTime.toISOString(),
        selectedDriverForReport,
        filterType // Add filterType parameter
      );

      console.log("Full API Response:", response);
      console.log("Response.data:", response.data);
      console.log("Response.data.status:", response.data?.status);
      console.log("Response.data.data:", response.data?.data);

      // Check for different possible response structures
      let orderData = null;
      if (response.data && response.data.status === 1 && response.data.data) {
        orderData = response.data.data;
      } else if (response.data && response.data.data) {
        // Fallback: check if data exists directly
        orderData = response.data.data;
      } else if (response.data && Array.isArray(response.data)) {
        // Fallback: response.data might be the array directly
        orderData = response.data;
      } else {
        console.error("Unexpected response structure:", response);
        showErrorNotification("Failed to fetch order data - unexpected response structure.");
        return;
      }

      if (!orderData || orderData.length === 0) {
        showErrorNotification("No orders found for the selected criteria.");
        return;
      }

      // Convert data to CSV and download
      const csvContent = convertToCSV(orderData, filterType, driversList.find(driver => driver.id === selectedDriverForReport)?.fullNameEn);
      
      // Get driver name from selected dropdown
      const selectedDriver = driversList.find(driver => driver.id === selectedDriverForReport)?.fullNameEn || 'driver';
      
      // Create and download the file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const filterTypeText = filterType === "pickup" ? "pickup" : "dropoff";
      const filename = `order_delay_report_${selectedDriver}_${filterTypeText}_${startDate}_to_${endDate}.csv`;

      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Close dialog immediately after download is triggered (same as LaundryOrdersView)
      setOrderDelayReportModal(false);
      showSuccessNotification("Order delay report downloaded successfully");
      // Reset form
      setSelectedDriverForReport("");
      setStartDate("");
      setEndDate("");
      setFilterType("pickup");
      
    } catch (ex) {
      showErrorNotification("Failed to download order delay report");
    } finally {
      // Only reset isDownloading after everything is complete
      setIsDownloading(false);
      setIsLoading(false);
    }
  };

  const convertToCSV = (data, filterType, selectedDriverName) => {
    if (!data || data.length === 0) {
      return "";
    }

    // Define CSV headers
    const headers = [
      "Order ID",
      filterType === "pickup" ? "Pickup Date" : "Dropoff Date",
      filterType === "pickup" ? "Pickup Slot" : "Dropoff Slot",
      filterType === "pickup" ? "Picked Up At" : "Dropped Off At",
      "Delay in Minutes",
      "Is Delayed",
      "Driver",
      "Month"
    ];

    // Helper function to escape CSV values
    const escapeCSV = (value) => {
      if (value === null || value === undefined) return '""';
      const stringValue = String(value);
      // If value contains comma, quote, or newline, wrap in quotes and escape internal quotes
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    };

    // Helper function to format date as "1-Aug-25"
    const formatDateForCSV = (dateString) => {
      if (!dateString) return "";
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          console.warn("Invalid date string:", dateString);
          return dateString;
        }
        const day = date.getDate();
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        const year = date.getFullYear().toString().slice(-2); // Get last 2 digits of year
        return `${day}-${month}-${year}`;
      } catch (e) {
        console.error("Error formatting date:", e, "for dateString:", dateString);
        return dateString;
      }
    };

    // Helper function to format datetime as "7/31/2015 19:58"
    const formatDateTimeForCSV = (dateString) => {
      if (!dateString) return "";
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          console.warn("Invalid datetime string:", dateString);
          return dateString;
        }
        const month = date.getMonth() + 1; // getMonth() returns 0-11
        const day = date.getDate();
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${month}/${day}/${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      } catch (e) {
        console.error("Error formatting datetime:", e, "for dateString:", dateString);
        return dateString;
      }
    };

    // Helper function to format month as "Aug-25"
    const formatMonthForCSV = (dateString) => {
      if (!dateString) return "";
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
          console.warn("Invalid date string:", dateString);
          return dateString;
        }
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        const year = date.getFullYear().toString().slice(-2); // Get last 2 digits of year
        return `${month}-${year}`;
      } catch (e) {
        console.error("Error formatting month:", e, "for dateString:", dateString);
        return dateString;
      }
    };

    // Create CSV rows with proper escaping
    const csvRows = data.map(item => [
      escapeCSV(item.orderId || ""),
      escapeCSV(formatDateForCSV(item.orderDate)),
      escapeCSV(item.orderSlot || ""),
      escapeCSV(formatDateTimeForCSV(item.orderCompletedAt)),
      escapeCSV(item.delayMinutes || 0),
      escapeCSV((item.delayMinutes || 0) > 0 ? "Yes" : "No"),
      escapeCSV(selectedDriverName || ""),
      escapeCSV(formatMonthForCSV(item.orderDate))
    ]);

    // Combine headers and rows with proper escaping
    const escapedHeaders = headers.map(header => escapeCSV(header));
    return [escapedHeaders.join(","), ...csvRows.map(row => row.join(","))].join("\n");
  };

  const formatDateOnly = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.warn("Invalid date string:", dateString);
        return dateString;
      }
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: '2-digit' 
      });
    } catch (e) {
      console.error("Error formatting date:", e, "for dateString:", dateString);
      return dateString;
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.warn("Invalid date string:", dateString);
        return dateString;
      }
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: '2-digit' 
      }) + " " + date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });
    } catch (e) {
      console.error("Error formatting datetime:", e, "for dateString:", dateString);
      return dateString;
    }
  };

  const updateDriverAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateDriver(id,fullNameEn,fullNameAr,mobileNumber,isActive);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Driver Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update driver");
      setIsLoading(false);
    }
  };

  const accessDriverShiftsPage = () => {
    let history = createHistory();
    history.push("/admin/driver-shifts");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  const accessDriverVehiclesPage = () => {
    let history = createHistory();
    history.push("/admin/vehicles");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };


  useAsyncEffect(async () => {
    if(executeUpdate){
        updateDriverAction();
    }
    else{
      fetchDrivers();
      fetchVehicles();
      fetchShifts();
    }
  }, [executeUpdate,forceRefresh]);

  const makeTableRow = (info) => {
    if(info.isActive == 0){
      info.isActiveText = "No";
    }
    else{
      info.isActiveText = "Yes";
    }
    if(info?.vehicle?.vehicleNumber){
      info.vehicleNumber = info.vehicle.vehicleNumber;
    }
    else{
      info.vehicleNumber = "NaN";
    }
    if(info?.shift?.shiftName){
      info.shiftName = info.shift.shiftName;
    }
    else{
      info.shiftName = "NaN";
    }
    // for (var i=0; i < countries.length; i++) {
    //   if(countries[i].id == info.countryId){
    //     info.countryText = countries[i].nameEn;
    //     break;
    //   }
    // }
    return {
      ...info,
      idForm: (
        "D"+zeroFill(info.id,5)
      ),
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          
          <div style={{ display: "inline-block" }}>
            {info.isActive == 1 ? (
              <Tooltip title="Disable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedInfo,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Disable Driver","Are you sure you would like to disable the driver "+info.fullNameEn+"?",async () =>  {
                    setCurrentRecord(info);
                    setIsActive(Math.abs(info.isActive-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                    
                  })}}
                >
                  <Box component={Block} />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title="Enable">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Enable Driver","Are you sure you would like to enable the driver "+info.fullNameEn+"?",async () => {
                    setCurrentRecord(info);
                    setIsActive(Math.abs(info.isActive-1));
                    setAlert(null);
                    setExecuteUpdate(true);
                  })}}
                >
                  <Box component={Check} />
                </Button>
              </Tooltip>
              
            )}
          </div>
        
          <Tooltip title="Assign Vehicle">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedPrimary,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddVehicleModal(true);
            }}>
              <Box component={DirectionsCar} />
            </Button>
          </Tooltip>
          <Tooltip title="Assign Shift">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddShiftModal(true);
            }}>
              <Box component={TimerRounded} />
            </Button>
          </Tooltip>

        </div>
        
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Drivers</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "fullNameEn",
                    text: "Name English",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "fullNameAr",
                    text: "Name Arabic",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "mobileNumber",
                    text: "Mobile Number",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "vehicleNumber",
                    text: "Vehicle Number",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "shiftName",
                    text: "Shift Name",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "isActiveText",
                    text: "Is Enabled",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  // {
                  //   dataField: "countryText",
                  //   text: "Country",
                  //   sort: true,
                  //   style: {'whiteSpace': 'normal'}
                  // },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        <Tooltip
                          title="Add new driver"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedPrimary,
                            }}
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                          >
                            <span>Add</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title={"Driver Shifts"}
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedSuccess,
                            }}
                            onClick={() => {
                              accessDriverShiftsPage();
                            }}
                          >
                            <span>Shifts</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title={"Driver Vehicles"}
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedWarning,
                            }}
                            onClick={() => {
                              accessDriverVehiclesPage();
                            }}
                          >
                            <span>Vehicles</span>
                          </Button>
                        </Tooltip>

                        <Tooltip
                          title="Download Order Delay Report by Driver"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedInfo,
                            }}
                            onClick={() => {
                              setOrderDelayReportModal(true);
                            }}
                          >
                            <Box component={Assessment} />
                            <span style={{ marginLeft: "5px" }}>Order Delay Report</span>
                          </Button>
                        </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          <ExportCSVButton
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                            {...props.csvProps}
                          >
                            <span className="MuiButton-label">Download</span>
                          </ExportCSVButton>
                        {/* </Tooltip> */}

                       
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Driver
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>

                <FormGroup>
                  <FormLabel>Full Name (English)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Full Name (English)"
                    value={fullNameEn ?? ""}
                    onChange={(e) => setFullNameEn(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Full Name (Arabic)</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Full Name (Arabic)"
                    value={fullNameAr ?? ""}
                    onChange={(e) => setFullNameAr(e.target.value)}
                  />
                </FormGroup>


                <FormGroup>
                  <FormLabel>Mobile Number</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Without + and 00. Example 97312345678"
                    value={mobileNumber ?? ""}
                    onChange={(e) => setMobileNumber(e.target.value)}
                  />
                </FormGroup>
{/* 

                <FormGroup>
                  <FormLabel>Country</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={countryId} onChange={(e) => setCountryId(e.target.value)} IconComponent={KeyboardArrowDown}>
                    {countries.map(function(country, i){
                        return <MenuItem value={country.id}>{country.nameEn}</MenuItem>;
                    })}
                    </Select>
                  </FormControl>
                </FormGroup> */}

                <FormGroup>
                  <FormLabel>Is Enabled</FormLabel>
                  <FormControl variant="outlined" fullWidth>
                    <Select value={isActive} onChange={(e) => setIsActive(e.target.value)} IconComponent={KeyboardArrowDown}>
                      <MenuItem value={1}>Yes</MenuItem>
                      <MenuItem value={0}>No</MenuItem>
                    </Select>
                  </FormControl>
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addDriverAction() : updateDriverAction()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + " " + classes.modalSmall,
        }}
        open={addVehicleModal && !isLoading}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setAddVehicleModal(false)}
      >
        <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    Assign Vehicle
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                  <FormGroup>
          <FormLabel>Select Vehicle</FormLabel>
          <FormControl variant="outlined" fullWidth>
          <Select
          value={selectedDriverVehicle}
          onChange={(e) => setSelectedDriverVehicle(e.target.value)}
          IconComponent={KeyboardArrowDown}
          >
          {vehicles.map((vehicle) => (
            <MenuItem key={vehicle.id} value={vehicle.id}>
              {vehicle.vehicleNumber}
            </MenuItem>
          ))}
          </Select>
          </FormControl>
        </FormGroup>
        </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setAddVehicleModal(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={() => assignVehicleAction()}
            classes={{
              root: classes.buttonContainedPurple100,
            }}
            variant="contained"
          >
            Assign
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + " " + classes.modalSmall,
        }}
        open={addShiftModal && !isLoading}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setAddShiftModal(false)}
      >
        <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    Assign Shift
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>
                  <FormGroup>
          <FormLabel>Select Shift</FormLabel>
          <FormControl variant="outlined" fullWidth>
            <Select
          
              onChange={(e) => setSelectedDriverShift(e.target.value)}
              IconComponent={KeyboardArrowDown}
            >
              {shifts.map((shift) => (
                <MenuItem key={shift.id} value={shift.id}>
                  {shift.shiftName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FormGroup>
        </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setAddShiftModal(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={() => assignShiftAction()}
            classes={{
              root: classes.buttonContainedPurple100,
            }}
            variant="contained"
          >
            Assign
          </Button>
        </DialogActions>
      </Dialog>

      {/* Order Delay Report Dialog */}
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + " " + classes.modalSmall,
        }}
        open={orderDelayReportModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOrderDelayReportModal(false)}
      >
        <DialogTitle
          disableTypography
          className={classes.modalHeader}
        >
          <h4 className={classes.modalTitle}>
            Order Delay Report by Driver
          </h4>
        </DialogTitle>
        <DialogContent
          className={classes.modalBody + " " + classes.modalSmallBody}
        >
          <form>
            <FormGroup>
              <FormLabel>Select Driver</FormLabel>
              <FormControl variant="outlined" fullWidth>
                <Select
                  value={selectedDriverForReport}
                  onChange={(e) => setSelectedDriverForReport(e.target.value)}
                  IconComponent={KeyboardArrowDown}
                >
                  {data.map((driver) => (
                    <MenuItem key={driver.id} value={driver.id}>
                      {driver.fullNameEn} ({driver.idForm})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </FormGroup>

            <FormGroup>
              <FormLabel>Start Date</FormLabel>
              <TextField
                fullWidth
                type="date"
                variant="outlined"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>End Date</FormLabel>
              <TextField
                fullWidth
                type="date"
                variant="outlined"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Filter Type</FormLabel>
              <FormControl variant="outlined" fullWidth>
                <Select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  IconComponent={KeyboardArrowDown}
                >
                  <MenuItem value="pickup">Pickup</MenuItem>
                  <MenuItem value="dropoff">Dropoff</MenuItem>
                </Select>
              </FormControl>
            </FormGroup>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOrderDelayReportModal(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={downloadOrderDelayReport}
            classes={{
              root: classes.buttonContainedPurple100,
            }}
            variant="contained"
            disabled={isDownloading}
          >
            {isDownloading ? "Downloading..." : "Download Report"}
          </Button>
        </DialogActions>
      </Dialog>


    </>
    
  );
};

export default DriversTable;
